import {Button as AntButton} from 'antd';
import cn from 'classnames';
import React, {ReactNode, FC, MouseEventHandler} from 'react';

import {DynamicIcon} from 'components/dynamic-icon';
import {EButtonType} from 'entities/metadata';

interface IActionButtonProps {
    children: ReactNode;
    actionIcon?: string;
    onClick?: MouseEventHandler<HTMLElement>;
    buttonType?: EButtonType;
    disabled?: boolean;
}

/**
 * Добавляет любому action css стили и иконку
 * @param actionIcon назывние иконки
 * @param children текст в кнопке
 * @param buttonType тип кнопки primary(синяя), default(серая) и т. д.
 * @param props
 */
export const ActionButton: FC<IActionButtonProps> = ({
    actionIcon,
    children,
    buttonType,
    ...props
}: IActionButtonProps) => (
    <AntButton
        className={cn('table-action', buttonType)}
        {...props}
    >
        {actionIcon && ((
            <div className="action-icon">
                <DynamicIcon
                    type={actionIcon}
                    style={{fontSize: 16}}
                />
            </div>
        ))}
        {children}
    </AntButton>
);
